import Office from "examples/Icons/Office";
import Company from "layouts/company";
import InvestmentOpportunity from "layouts/investmentOpportunity";
import Investor from "layouts/investor";
import Settings from "layouts/settings";
import Ghollaks from "./layouts/ghollaks";
import GhollakMinBalance from "layouts/ghollakMinBalance";
import Qrcode from "layouts/qrcode";
import InvestmentDashboard from "layouts/investmentDashboard";
import ProfitCalculation from "layouts/profitCalculation";
import WithdrawTransactions from "layouts/withdrawTransactions";
import Badge from "layouts/badge";
import Mission from "layouts/mission";
import Dashboard from "layouts/dashboard";


const routes = [
    {
        type: "collapse",
        name: "داشبورد",
        key: "dashboard",
        role: ["sudo"],
        route: "/dashboard",
        icon: <Office size="12px" />,
        component: <Dashboard />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "قلک ها",
        key: "ghollaks",
        role: ["sudo"],
        route: "/ghollaks",
        icon: <Office size="12px" />,
        component: <Ghollaks />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "فرصت های سرمایه گذاری",
        key: "investmentOpportunity",
        role: ["sudo"],
        route: "/investmentOpportunity",
        icon: <Office size="12px" />,
        component: <InvestmentOpportunity />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "داشبورد فرصت",
        key: "investmentDashboard",
        role: ["sudo"],
        route: "/investmentDashboard",
        icon: <Office size="12px" />,
        component: <InvestmentDashboard />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "محاسبه سود",
        key: "profitCalculation",
        role: ["sudo"],
        route: "/profitCalculation",
        icon: <Office size="12px" />,
        component: <ProfitCalculation />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "درخواست های برداشت",
        key: "withdrawTransactions",
        role: ["sudo"],
        route: "/withdrawTransactions",
        icon: <Office size="12px" />,
        component: <WithdrawTransactions />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "سرمایه گذاران",
        key: "investor",
        role: ["sudo"],
        route: "/investor",
        icon: <Office size="12px" />,
        component: <Investor />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "کیوآر کد",
        key: "qrcode",
        role: ["sudo"],
        route: "/qrcode",
        icon: <Office size="12px" />,
        component: <Qrcode />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "تاریخچه موجودی قلک",
        key: "ghollakMinBalance",
        role: ["sudo"],
        route: "/ghollakMinBalance",
        icon: <Office size="12px" />,
        component: <GhollakMinBalance />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "شرکت ها",
        key: "company",
        role: ["sudo"],
        route: "/company",
        icon: <Office size="12px" />,
        component: <Company />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "نشان ها",
        key: "badge",
        role: ["sudo"],
        route: "/badge",
        icon: <Office size="12px" />,
        component: <Badge />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "ماموریت ها",
        key: "mission",
        role: ["sudo"],
        route: "/mission",
        icon: <Office size="12px" />,
        component: <Mission />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "تنظیمات",
        key: "settings",
        role: ["sudo"],
        route: "/settings",
        icon: <Office size="12px" />,
        component: <Settings />,
        noCollapse: true,
    }
];

export default routes;
